module.exports = __webpack_public_path__ + "assets/smile.f2ae153238aef25880ac423ece7fb324.png";